module.exports = "/fonts/iconsmind.eot?1cd6a624d6a7569e37128c287a443e7e";


//////////////////
// WEBPACK FOOTER
// ./resources/assets/js/assets/fonts/iconsmind/iconsmind.eot?ioqkm7
// module id = Jfwk
// module chunks = 35